import React from "react";
import { Icon } from "./Icon";
export const IconChevronLeft = (props) => (
  <Icon {...props}>
    <path d="M15 18l-6-6 6-6" />
  </Icon>
);
